// This file is responsible for keeping translations related business in one place.
// It fetches the locales and regions from the config files, and generates the needed values here.
import NextI18Next from 'next-i18next';
import Locale from '@com/core/common/utils/locale';
import { IS_BROWSER } from '@com/core/common/baseConfig';

const SUBPATH_VARIATIONS: { [key: string]: string } = Object.assign({}, ...Locale.getSubpathVariations());

const ALL_LOCALES = Object.keys(SUBPATH_VARIATIONS);

// --- Set up the i18next config
const nextI18Next = new NextI18Next({
    defaultLanguage: ALL_LOCALES[0],
    otherLanguages: ALL_LOCALES.splice(1, ALL_LOCALES.length - 1),
    browserLanguageDetection: false,
    localeSubpaths: SUBPATH_VARIATIONS,
    localePath: IS_BROWSER ? 'locales' : 'public/locales',
    preload: IS_BROWSER ? false : ALL_LOCALES,
    backend: IS_BROWSER ? { loadPath: `/locales/{{lng}}/{{ns}}.json`, crossDomain: true } : undefined,
    ignoreRoutes: ['/_next/', '/locales/', '/images/', '/_svc/', '/hc/', '/api/'],
    cleanCode: true, // language will be lowercased EN --> en while leaving full locales like en-US
    // debug: true,
});

export default nextI18Next;

export const { Link, Router, Trans, appWithTranslation, i18n, useTranslation, withTranslation } = nextI18Next;
